<template>
    <v-app v-if="isLoading">
        <loading />
    </v-app>
    <v-card
        v-else
        flat
        color="gray"
        rounded="xl"
        class="mt-8 mx-auto rounded-tr-0 EK-shadow IMTOrange"
        max-width="360"
    >
        <v-card-text>
            <v-col cols="12">
                <v-row>
                    <v-col col="2"></v-col>
                    <v-col cols="8">
                        <v-card-title
                            class="IMThemeGray rounded-xl rounded-tr-0 py-2 justify-content-center text-white"
                            >المحافظات</v-card-title
                        >
                    </v-col>
                    <v-col col="2"></v-col>
                    <v-col
                        v-for="(city, index) in citiesList"
                        :key="index"
                        cols="3"
                        class="p-1 city-card"
                    >
                        <router-link :to="'./' + index">
                            <div
                                class="white h-100 w-100 d-flex justify-content-center align-items-center rounded-lg"
                                :class="{ active: id == index }"
                            >
                                <span>
                                    {{ city.name }}
                                </span>
                            </div>
                        </router-link>
                    </v-col>
                </v-row>
            </v-col>
        </v-card-text>
        <v-card-actions class="justify-content-around pb-4">
            <v-btn
                class="rounded-xl rounded-tr-0 px-10 py-5"
                v-if="id != -1"
                @click="submitRemoveCity()"
                transition="slide-x-transition"
                >حذف
                <img src="/media/svg/table/delete.svg" alt="delete" class="pr-2"/>
                </v-btn
            >
        </v-card-actions>
    </v-card>
</template>
<style lang="scss" scoped>
.city-card {
    height: 72px;
    width: 72px;
    div {
        cursor: pointer;
        transition: all 0.3s linear;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        span {
            padding: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        &.active {
            background: linear-gradient(
                to top,
                transparent,
                #f69c3c
            ) !important;
        }
    }
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import loading from "@/components/loading";
import Swal from "sweetalert2";
export default {
    data: () => ({}),
    props: {
        id: String
    },
    components: {
        loading
    },
    created() {
        this.fetchCitiesList();
        this.setLoading(false);
    },
    computed: {
        ...mapGetters(["citiesList", "isLoading"])
    },
    methods: {
        ...mapActions(["fetchCitiesList", "removeCity", "clearCityInput","setLoading"]),
        activeCity(city, i) {
            this.isThisCityActive = i;
        },
        submitRemoveCity() {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                buttonsStyling: true
            });
            swalWithBootstrapButtons
                .fire({
                    title: "هل أنت متأكد؟",
                    text: "هل فعلاً تريد حذف المدينة ؟",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "نعم!",
                    cancelButtonText: "إلغاء",
                    reverseButtons: false
                })
                .then(result => {
                    if (result.value) {
                        this.removeCity(this.id);
                        if (this.id != -1) {
                            this.$router.push("./-1");
                        }
                    }
                });
        }
    }
};
</script>
